export const types = [
  {
    label: 'contracts.new.source_template',
    image: '/images/listing/createDocument/papel.svg',
    type: 'template',
    role: 'CREATE_NEW_TEMPLATE',
  },
  {
    label: 'contracts.new.source_questionnaire',
    image: '/images/listing/createDocument/examen.svg',
    type: 'questionnaire',
    role: 'CREATE_NEW_QUESTIONNAIRE',
  },
  {
    label: 'contracts.new.source_file',
    image: '/images/listing/createDocument/subir.svg',
    type: 'source',
    role: 'CREATE_NEW_UPLOAD',
  },
  {
    label: 'contracts.new.source_blank',
    image: '/images/listing/createDocument/blanco.svg',
    type: 'blank',
    role: 'CREATE_NEW_BLANK',
  },
  {
    label: 'contracts.new.source_file_multiple',
    image: '/images/listing/createDocument/Page-1.svg',
    type: 'multiple',
    role: 'CREATE_NEW_MIGRATE',
  },
  {
    label: 'contracts.new.source_massive',
    image: '/images/listing/createDocument/file-excel.svg',
    type: 'massive',
    role: 'CREATE_NEW_MASSIVE',
  },
  {
    label: 'contracts.new.source_pagare',
    image: '/images/listing/createDocument/papel.svg',
    type: 'pagare',
    role: 'CREATE_NEW_PAGARE',
  },
  {
    label: 'contracts.new.source_application',
    image: '/images/listing/createDocument/papel.svg',
    type: 'application',
    role: 'CREATE_NEW_APPLICATION',
  },
  // {
  //   label: "contracts.new.source_external",
  //   image: "/images/listing/createDocument/external.svg",
  //   type: "application",
  //   role: "CREATE_NEW_EXTERNAL",
  // },
];

export const contractStatusOptions = [
  {
    label: 'contracts.status.EMPTY',
    value: 'EMPTY',
  },
  {
    label: 'contracts.status.RECEIVED_SIGNED',
    value: 'RECEIVED_SIGNED',
  },
];
export const fileTypes = ['.doc', '.docx', 'application/pdf', '.xlsx', '.xls', '.xml'];

export default types;
